var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDhand(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 85,
    viewBox: "0 0 71 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.8897 80.9999C45.8897 80.9999 45.5307 75.2557 45.8897 68.9131C46.2487 62.5705 46.7274 61.1345 45.1717 58.023C43.616 54.9115 41.3422 48.4493 42.1799 40.4313C43.0176 32.4133 43.6782 33.61 44.1262 30.9772C44.5733 28.3445 45.411 24.0363 47.4454 23.6773C49.4799 23.3183 51.5985 22.6529 53.1542 26.1234",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5588 79.3247C64.5588 79.3247 63.2424 71.187 63.6014 67.3576C63.9604 63.5281 63.2424 62.6904 62.8834 60.4166C62.5244 58.1429 63.9604 54.1985 65.2768 52.1612C66.5932 50.1239 66.7129 48.6888 67.4309 47.6118C68.1489 46.5347 69.226 45.338 68.1489 41.7479C67.0719 38.1577 67.0719 37.32 67.0719 36.0036C67.0719 34.6872 66.036 32.8922 65.7163 31.9348C65.7163 31.9348 65.1571 30.5581 65.2175 28.764C65.2778 26.9689 62.824 25.4725 60.6699 28.764C60.6699 28.764 59.4139 30.7381 59.4732 33.1315C59.5335 35.5249 59.8322 36.602 60.6106 37.9184C61.388 39.2348 61.1486 40.3118 60.9696 42.1069",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6935 22.5409C51.6935 22.5409 53.3095 25.7117 53.4886 27.6868C53.6685 29.6609 56.6603 29.9002 57.5574 28.8241C58.4554 27.7471 57.3784 24.9946 57.139 23.7386C56.8997 22.4825 56.241 18.8923 54.5062 18.5324C52.7705 18.1734 51.6341 18.2337 50.9755 19.3701C50.3177 20.5074 49.9587 21.9521 50.0181 23.324",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3409 26.8164C53.3409 26.8164 54.0273 29.4214 50.8565 29.1821C50.8565 29.1821 48.5828 29.1974 47.207 26.8164",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2485 28.3445C46.2485 28.3445 48.0943 29.545 48.8765 28.5561",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0127 29.0461C50.0127 29.0461 50.163 31.3362 47.5781 31.8742",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9038 27.7559C57.9038 27.7559 58.0781 29.9731 60.3011 29.4581",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8154 19.6131C55.8154 19.6131 56.1658 16.2575 57.9082 16.0182C59.6516 15.7789 60.609 15.6592 61.5664 16.8559C62.5237 18.0526 62.2241 18.4719 62.4041 20.7447C62.5831 23.0185 63.0618 26.8154 63.0618 26.8154",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M62.7593 24.2699C62.7593 24.2699 63.3021 24.8749 63.7205 21.8228C64.1389 18.7707 64.0795 16.3773 64.6779 13.5655C65.2762 10.7537 65.3959 8.2406 65.3356 6.74423C65.2762 5.24882 64.7975 1 67.7893 1C70.7811 1 70.3618 7.10325 70.3618 9.43636C70.3618 11.7695 70.2421 17.6334 69.7041 20.6261C69.1651 23.6179 69.4044 26.3416 69.4044 29.1984C69.4044 32.0552 69.1651 35.1667 68.8664 36.4228C68.5667 37.6788 67.9052 40.9195 67.9052 40.9195",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5312 72V43.5625H23.2812C25.7812 43.5625 28.0143 44.1289 29.9805 45.2617C31.9596 46.3815 33.5026 47.9831 34.6094 50.0664C35.7161 52.1367 36.2695 54.4935 36.2695 57.1367V58.4453C36.2695 61.0885 35.7227 63.4388 34.6289 65.4961C33.5482 67.5534 32.0182 69.1484 30.0391 70.2812C28.0599 71.4141 25.8268 71.987 23.3398 72H14.5312ZM20.3906 48.3086V67.293H23.2227C25.5143 67.293 27.2656 66.5443 28.4766 65.0469C29.6875 63.5495 30.306 61.4076 30.332 58.6211V57.1172C30.332 54.2266 29.7331 52.0391 28.5352 50.5547C27.3372 49.0573 25.5859 48.3086 23.2812 48.3086H20.3906Z",
    fill: "url(#paint0_diamond)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_diamond",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.2424 60.8929) rotate(88.0754) scale(45.1147 45.0815)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD458",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9BF2E"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDhand);
export default __webpack_public_path__ + "static/media/Dhand.0f74776a3fe3a0d35494d13162c13f0d.svg";
export { ForwardRef as ReactComponent };